import { render, staticRenderFns } from "./SBSYCBSK.vue?vue&type=template&id=725afb94&scoped=true&"
import script from "./SBSYCBSK.vue?vue&type=script&lang=js&"
export * from "./SBSYCBSK.vue?vue&type=script&lang=js&"
import style0 from "./SBSYCBSK.vue?vue&type=style&index=0&id=725afb94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725afb94",
  null
  
)

export default component.exports